import { Link } from "react-router-dom";

export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="vion-gold" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#F1DC9B" />
        <stop offset=".55" stopColor="#C9A54C" />
        <stop offset="1" stopColor="#8E6B22" />
      </linearGradient>
    </defs>
    <rect width="40" height="40" rx="10" fill="#2A0B4A" />
    <rect x=".5" y=".5" width="39" height="39" rx="9.5" fill="none" stroke="url(#vion-gold)" strokeOpacity=".55" />
    <path d="M9.5 11.5 20 30l10.5-18.5" fill="none" stroke="#fff" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="20" cy="11.5" r="3.4" fill="url(#vion-gold)" />
  </svg>
);

export const Logo = ({ testid = "site-logo", onClick }) => (
  <Link to="/" onClick={onClick} data-testid={testid} aria-label="VION Tech home" className="group flex items-center gap-3">
    <LogoMark className="h-9 w-9 transition-transform duration-500 group-hover:rotate-[-8deg]" />
    <span className="flex items-baseline gap-1.5 leading-none">
      <span className="font-display text-[22px] font-medium tracking-tight text-white">VION</span>
      <span className="font-mono text-[10px] tracking-[0.3em] text-gold">TECH</span>
    </span>
  </Link>
);
